<template>
  <section>
    <SectionContainer>
      <SectionHeader>
        <b slot="title">Aprenda com quem <span class="hl">entende</span> do assunto</b>
        <span slot="subtitle">especialistas em suas áreas produzino conteúdo relevante</span>
      </SectionHeader>

      <div class="containers">
        <HorizontalCarousel :items="authors" :options="{ group: 3 }">
          <template v-slot="{ items }">
            <AuthorDetailsAvatarBox
              v-for="(item, index) in items"
              :key="item.id"
              :class="{ 'mb-4': index !== items.length - 1 }"
              :user="item"
            />
          </template>
        </HorizontalCarousel>
      </div>
    </SectionContainer>
  </section>
</template>

<script>
  import { getAuthors } from '@/api/user.api'
  import SectionContainer from '@/components/layout/SectionContainer'
  import AuthorDetailsAvatarBox from '@/components/user/AuthorDetailsAvatarBox'
  import SectionHeader from '@/components/layout/SectionHeader'
  import HorizontalCarousel from '@/components/carousel/HorizontalCarousel'

  export default {
    components: {
      SectionContainer,
      AuthorDetailsAvatarBox,
      SectionHeader,
      HorizontalCarousel,
    },

    data: () => ({
      authors: []
    }),

    mounted () {
      this.fetchAuthorsHighlight()
    },

    methods: {
      async fetchAuthorsHighlight () {
        const res = await getAuthors()

        this.authors = res.data
      }
    }
  }
</script>
